import $ from 'jquery';
import Slideout from 'slideout';

import Component from '../Component';
import { Breakpoints } from '../constants';

export default class Drawer extends Component {
    MOBILE_DRAWER_SIZE = 300;
    DESKTOP_DRAWER_SIZE = 390;
    MOBILE_BREAKPOINT = Breakpoints.sm;

    constructor(theme, element) {
        super(theme, element);
        this.slideouts = {};
        this.isMobile = this.theme.breakpoint.order <= this.MOBILE_BREAKPOINT.order;

        this.load();
    }

    load = () => {
        // Close sliders if they're open
        if (this.slideouts && this.slideouts.left) {
            this.slideouts.left.close();
        }
        if (this.slideouts && this.slideouts.right) {
            this.slideouts.right.close();
        }

        /* Move mobile menu out of section to document body because the slideout
           needs to put it to the sidebar, but it can't be in the body from the beginning
           because it needs section config */
        var body_menu = $('body > #theme-menu');
        var main_body_menu = $('#main-body #theme-menu');
        if (main_body_menu.length > 0) {
            body_menu.remove();
            $('body').append(main_body_menu);
        }

        var main_body = document.querySelector('#main-body');
        var left_menu = document.querySelector('#theme-menu');
        var right_menu = document.querySelector('#cartSlideoutWrapper');
        var overlay = document.querySelector('#slideout-overlay');

        /* Mobile Menu */

        var slideoutLeft = this.createDrawer('left', main_body, left_menu, right_menu, overlay);

        $('.slide-menu-mobile').off('click').on('click', function() {
            slideoutLeft.toggle();
        });

        $('.mobile-menu-close').on('click', function () {
            slideoutLeft.close();
        });

        // Disable mobile drawer on desktop
        if (this.theme.breakpoint.order <= this.MOBILE_BREAKPOINT.order) {
            slideoutLeft.disableTouch();
        }

        // Add events for sidebar manipulation from outside
        $(left_menu)
            .on('mobile:toggle', slideoutLeft.toggle.bind(slideoutLeft))
            .on('mobile:open', slideoutLeft.open.bind(slideoutLeft))
            .on('mobile:close', slideoutLeft.close.bind(slideoutLeft));

        /* Cart */
        if (!right_menu) {
            // Cart drawer is disabled in the settings
            return;
        }
        var slideoutRight = this.createDrawer('right', main_body, right_menu, left_menu, overlay);

        // Toggle button
        $('.slide-menu-cart').off('click').on('click', function (e) {
            slideoutRight.toggle();
            // prevent non-ajax basket
            e.preventDefault();
            return false;
        });

        $('.cart-menu-close').on('click', function (e) {
            slideoutRight.close();
        });

        // Add events for sidebar manipulation from outside
        $(right_menu)
            .on('cart:toggle', slideoutRight.toggle.bind(slideoutRight))
            .on('cart:open', slideoutRight.open.bind(slideoutRight))
            .on('cart:close', slideoutRight.close.bind(slideoutRight));
    }

    onWindowResizeBreakpoint = ({ breakpoint, oldBreakpoint }) => {
        const wasMobile = this.isMobile;
        this.isMobile = breakpoint.order <= this.MOBILE_BREAKPOINT.order;

        if (this.isMobile === wasMobile) {
            // mobile <=> desktop was not changed
            return;
        }

        if (this.isMobile) {
            this.slideouts.left.disableTouch();
        } else {
            this.slideouts.left.enableTouch();
        }

        if (!this.slideouts.right) {
            // cart slider is disabled
            return;
        }

        // Resize right drawer based on window width
        const slideout = this.slideouts.right;
        const padding = (this.isMobile) ? this.MOBILE_DRAWER_SIZE : this.DESKTOP_DRAWER_SIZE;
        slideout._translateTo = slideout._padding = padding * slideout._orientation;
        if (slideout._opened) {
            var transform = "translateX(" + (padding * slideout._orientation) + "px)";
            slideout.panel.style.webkitTransform = transform;
            slideout.panel.style.transform = transform;
        }
    }

    /**
     * Create side drawer
     *
     * @param {'left' | 'right'} side
     */
    createDrawer = (side, panel, menu, hidden_menu, overlay) => {
        var padding = this.MOBILE_DRAWER_SIZE;
        if (side === 'right' && !this.isMobile) {
            padding = this.DESKTOP_DRAWER_SIZE;
        }

        var slideout = new Slideout({
            'panel': panel,
            'menu': menu,
            'padding': padding,
            'tolerance': 70,
            'side': side,
            'touch': false
        });
        var dir = (side === 'right') ? -1 : 1;
        this.slideouts[side] = slideout;
        menu.classList.add('slideout-panel-hidden');

        var $overlay = $(overlay);
        overlay.addEventListener('click', slideout.close.bind(slideout));

        // Handle slide to close
        var touch_start = null;
        overlay.addEventListener('touchstart', function (event) {
            if (!slideout.isOpen()) {
                return;
            }
            event.preventDefault();
            touch_start = event.touches[0].pageX;
        });
        overlay.addEventListener('touchmove', function (event) {
            if (!slideout.isOpen()) {
                return;
            }
            var offset = touch_start - event.touches[0].pageX;
            var translate = (dir * padding) - offset;
            if (Math.abs(translate) > padding) {
                translate = (dir * padding);
            }
            panel.style.webkitTransform ='translateX(' + translate + 'px)';
            panel.style.transform ='translateX(' + translate + 'px)';
        });
        overlay.addEventListener('touchend', function (event) {
            if (!slideout.isOpen()) {
                return;
            }
            var offset = touch_start - event.changedTouches[0].pageX;
            if (offset === 0 || Math.abs(offset) > 70) {
                slideout.close();
            } else {
                panel.style.webkitTransform = 'translateX(' + (dir * padding) + 'px)';
                panel.style.transform = 'translateX(' + (dir * padding) + 'px)';
            }
        });

        slideout.on('beforeopen', function() {
            menu.classList.remove('slideout-panel-hidden');
            if (hidden_menu) {
                hidden_menu.classList.add('slideout-panel-hidden');
            }
            $overlay.fadeIn();
            // document.body.style.overflowY = 'hidden';
            var marginTop = $(window).scrollTop() + 'px';
            panel.style.position = 'fixed';
            panel.style.marginTop = '-' + marginTop;
            // Apply oposite effect to the sticky header
            $('.sticky-header-wrapper.sticky').css({
                'margin-top': marginTop,
                'transform': 'translateY(0)'
            });
        });

        slideout.on('beforeclose', function () {
            $overlay.fadeOut();
            var scrollTop = -parseInt(panel.style.marginTop);
            panel.style.position = '';
            panel.style.marginTop = '';
            $(window).scrollTop(scrollTop);
        });

        slideout.on('close', function() {
            $('.sticky-header-wrapper').css({
                'margin-top': 0,
                'transform': ''
            });
            menu.classList.add('slideout-panel-hidden');
        });
        slideout.on('translate', function(translated) {
            var hidden = false;
            if (translated === 0) {
                hidden = true;
            } else if (side === 'left') {
                hidden = translated <= 0;
            } else if (side === 'right') {
                hidden = translated >= 0;
            }
            menu.classList.toggle('slideout-panel-hidden', hidden);
            if (hidden_menu) {
                hidden_menu.classList.toggle('slideout-panel-hidden', !hidden);
            }
        });

        return slideout;
    }
}